import { useEffect, useState } from 'react'
import { NetworkMember } from 'types/bvnkNetwork'

export const useBvnkMemberSearch = (
  debouncedSearchTerm: string,
  connectionList: NetworkMember[]
) => {
  const [filteredNetworkMembers, setFilteredNetworkMembers] = useState<NetworkMember[]>(
    connectionList ?? []
  )
  const [isFiltering, setIsFiltering] = useState(false)

  useEffect(() => {
    setIsFiltering(true)
    if (!!debouncedSearchTerm) {
      const filteredList = connectionList?.filter(connection => {
        return (
          connection?.account?.name?.toLowerCase().includes(debouncedSearchTerm?.toLowerCase()) ||
          connection?.account?.description
            ?.toLowerCase()
            .includes(debouncedSearchTerm?.toLowerCase())
        )
      })

      setFilteredNetworkMembers(filteredList)
    } else if (connectionList?.length) {
      setFilteredNetworkMembers([...connectionList])
    }
    setIsFiltering(false)
  }, [debouncedSearchTerm, connectionList])

  return { isFiltering, filteredNetworkMembers }
}
